// extracted by mini-css-extract-plugin
export var caretAnchor = "_vv-0";
export var dropdownContent = "_vv-1";